export default __webpack_public_path__ + "static/media/Sume_Premio_UsosMixtos.0f10aff9.png";